module.exports = __webpack_public_path__ + "img/srij.c879cc2a.png";